import styled from "styled-components"

export const CodeBlockWrapper = styled.div`
  font-family: "Hack", "SFMono-Regular", "Menlo", "Monaco", "Consolas",
    "Liberation Mono", "Courier New", monospace;
  position: relative;
  overflow: auto;

  pre[class*="language-"]::before {
    background: #d9d7e0;
    border-radius: 0 0 4px 4px;
    color: #232129;
    font-size: 12px;
    font-family: inherit;
    letter-spacing: 0.075em;
    line-height: 1;
    padding: 0.25rem 0.5rem;
    position: absolute;
    left: 1rem;
    text-align: right;
    text-transform: uppercase;
    top: 0;
  }

  pre[class~="language-swift"]::before {
    content: "Swift";
    background: #f05138;
    color: #fff;
  }

  pre[class~="language-kotlin"]::before {
    content: "Kotlin";
    background: #e10098;
    color: #fff;
  }

  pre[class~="language-java"]::before {
    content: "Java";
    background: #f89820;
    color: #fff;
  }

  pre[class~="language-js"]::before,
  pre[class~="language-javascript"]::before {
    content: "js";
    background: #f7df1e;
  }

  pre[class~="language-jsx"]::before {
    content: "jsx";
    background: #f7df1e;
  }

  pre[class~="language-typescript"]::before,
  pre[class~="language-ts"]::before {
    content: "ts";
    background: #294e80;
    color: #fff;
  }

  pre[class~="language-tsx"]::before {
    content: "tsx";
    background: #294e80;
    color: #fff;
  }

  pre[class~="language-graphql"]::before {
    content: "GraphQL";
    background: #e10098;
    color: #fff;
  }

  pre[class~="language-html"]::before {
    content: "html";
    background: #005a9c;
    color: #fff;
  }

  pre[class~="language-css"]::before {
    content: "css";
    background: #ff9800;
    color: #fff;
  }

  pre[class~="language-sh"]::before,
  pre[class~="language-bash"]::before {
    content: "bash";
  }

  pre[class~="language-json"]::before {
    content: "json";
    background: linen;
  }

  pre[class~="language-xml"]::before {
    content: "XML";
    background: #ff9800;
    color: #fff;
  }

  pre[class~="language-objectivec"]::before {
    content: "Objective-C";
    background: #294e80;
    color: #fff;
  }

  pre[class~="language-dart"]::before {
    content: "Dart";
    background: #0175c2;
    color: #fff;
  }
`

export const PreHeader = styled.div`
  font-family: "Hack", "SFMono-Regular", "Menlo", "Monaco", "Consolas",
    "Liberation Mono", "Courier New", monospace;
  background-color: var(--black);
  color: var(--white);
  font-size: 12px;
  line-height: 18px;
  padding: 8px 16px;
  border-radius: 5px 5px 0 0;
`

export const Pre = styled.pre<{ hasTitle: boolean }>`
  text-align: left;
  padding: 2rem 1rem 1rem 1rem;
  overflow: auto;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  border-radius: ${(props) =>
    props.hasTitle ? "0 0 5px 5px" : "5px 5px 5px 5px"};
  -webkit-overflow-scrolling: touch;
  overflow-wrap: break-word;
  box-shadow: 1px 1px 20px rgba(20, 20, 20, 0.27);

  code {
    float: left;
    min-width: 100%;
  }

  .highlight-line {
    background-color: var(--azure-grey);
    display: block;
    margin-right: -1rem;
    margin-left: -1rem;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .token-line {
    line-height: 150%;
    font-size: 14px;
    min-width: 100%;
  }
`

export const CopyCode = styled.button<{ hasTitle: boolean }>`
  position: absolute;
  right: 0;
  top: 0;
  border: none;
  border-radius: ${(props) => (props.hasTitle ? "0 0 0 5px" : "0 5px 0 5px")};
  padding: 4px 8px;
  background-color: var(--azure-grey);
  color: var(--snow);
  transition: background-color 50ms ease;
  font-size: 12px;
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }

  :not(:disabled) {
    :hover,
    :focus {
      background-color: var(--deep-orange);
    }
  }
`

export const LineNo = styled.span`
  font-size: 14px;
  color: var(--white);
  display: inline-block;
  width: 24px;
  user-select: none;
  opacity: 0.3;
`
